import { useSelector } from "react-redux";
import { selectCurrent } from "../../../../../../redux/settings/selectors";
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table";
import { selectRateCardsListItems } from "../../../../../../redux/rate-cards/selector";
import { rateCards } from "../../../../../../redux/rate-cards/action";
import { useNavigate } from "react-router-dom";


const TransporterRateCards = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
	const result = useSelector(selectCurrent)
	const { header, footer, currency } = result
    const orderItems = useSelector(selectRateCardsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'Name', headerName: 'Name', sortable: true, filter: true, isEdit: true },
          { field: 'LogisticsProviderName', headerName: 'LogisticsProvider Name', sortable: true, filter: true },
          { field: 'Description', headerName: 'Description', sortable: true, filter: true },
          { field: 'StartDateUtc', headerName: 'Start Date'  },
          { field: 'EndDateUtc', headerName: 'End Date'},
          { field: 'CreatedOnUtc', headerName: 'Created On'},
          { field: 'ModifiedOnUtc', headerName: 'Modified On' }
        ]);
      }
      const handleAdd=()=>{
        navigate(`${0}`)
      }
      const handleEdit=(data: any)=>{
        navigate(`${data?.Id}`)
      }
      const fetchRateCards=()=>{
        dispatch(rateCards.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/shipment/rate-cards/list`,entity:'rateCards',jsonData:{
          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
      }}))
      }   
	useEffect(() => {
        createColumnDefs()
        fetchRateCards()
	}, [])
  const handleDelete=(data: any)=>{
    dispatch(rateCards.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/shipment/rate-cards/delete`,
      entity: 'rateCards',
      jsonData: {
          Records: [
              {
                  Id: data.Id
              }
          ]
      }
  })).then(() => {
    dispatch(rateCards.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/shipment/rate-cards/list`,entity:'rateCards',jsonData:{
          
  }}))
  });
  }
  const additionButtons: any = [
    {
      name: 'Add RateCard',
      callback: () => handleAdd(),
    }
  ];
	return (
		<Table columnData={columnDefs} rowData={orderItems?.result?.items} setPageData={setPageData}
    paginationData={orderItems?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="Rate Cards" />
      
	);
};

export default TransporterRateCards;


